export default __webpack_public_path__ + "static/media/Ballroll_00259.43155d19.png";